import theme from '@services/theme'

export default {
    variants: theme.components.Tile.variants,
    valueColor: {
        default: {
            color: theme.palette.text.primary
        },
        success: {
            color: theme.palette.success.main
        },
        error: {
            color: theme.palette.error.main
        }
    }
}